export const EVENTS = {
  home: {
    landed: {
      eventName: 'LANDED_ON_HOME',
    },
    freeDemoClicked: {
      eventName: 'FREE_DEMO_CLICK',
      eventParams: {
        action: 'whatsapp_click',
        source: 'home_page'
      },
    },
    watchDemoVideosClicked: {
      eventName: 'WATCH_DEMO_VIDEOS_CLICKED',
      eventParams: {
        action: 'watch_demo_videos_clicked',
        source: 'home_page'
      },
    },
    startFreeTrialClicked: {
      eventName: 'START_FREE_TRIAL_CLICKED',
      eventParams: {
        action: 'start_free_trial_clicked',
        source: 'home_page'
      },
    },
    androidAppClicked: {
      eventName: 'ANDROID_APP_CLICKED',
      eventParams: {
        action: 'android_app_clicked',
        source: 'home_page'
      },
    },
    iphoneAppClicked: {
      eventName: 'IPHONE_APP_CLICKED',
      eventParams: {
        action: 'iphone_app_clicked',
        source: 'home_page'
      },
    },
    loginClicked: {
      eventName: 'LOGIN_BUTTON_CLICKED',
      eventParams: {
        action: 'login_button_clicked',
        source: 'header'
      },
    },
    contactUsClicked: {
      eventName: 'CONTACT_US_BUTTON_CLICKED',
      eventParams: {
        action: 'contact_us_button_clicked',
        source: 'header'
      },
    },
  },
  contact: {
    landed: {
      eventName: 'LANDED_ON_CONTACT',
    },
  },
  pricing: {
    landed: {
      eventName: 'LANDED_ON_PRICING',
    },
    signUpClicked: {
      eventName: 'FREE_SIGN_UP_CLICKED',
    },
    sliderClicked: {
      eventName: 'SLIDER_CLICKED',
    },
  },
  about: {
    landed: {
      eventName: 'LANDED_ON_ABOUT',
      eventParams: {},
    },
  },
  product: {
    landed: {
      eventName: 'LANDED_ON_PRODUCT',
      eventParams: {},
    },
  },
  login: {
    sendOtpClicked: {
      eventName: 'SEND_OTP_CLICKED',
      eventParams: {
        action: 'send_otp_clicked',
        step: 'phone_input'
      },
    },
    sendOtpSuccess: {
      eventName: 'SEND_OTP_SUCCESS',
      eventParams: {
        action: 'send_otp_success',
        step: 'otp_sent'
      },
    },
    sendOtpFailed: {
      eventName: 'SEND_OTP_FAILED',
      eventParams: {
        action: 'send_otp_failed',
        step: 'otp_send_error'
      },
    },
    submitOtpClicked: {
      eventName: 'SUBMIT_OTP_CLICKED',
      eventParams: {
        action: 'submit_otp_clicked',
        step: 'otp_verification'
      },
    },
    loginSuccess: {
      eventName: 'LOGIN_SUCCESS',
      eventParams: {
        action: 'login_success',
        step: 'login_complete'
      },
    },
    loginFailed: {
      eventName: 'LOGIN_FAILED',
      eventParams: {
        action: 'login_failed',
        step: 'otp_verification_error'
      },
    },
  },
  // Quotation Analytics Events
  quotation: {
    // Page Views
    landed: {
      eventName: 'QUOTATION_LANDED',
      eventParams: {
        page_type: 'quotation_list'
      },
    },
    newQuotationLanded: {
      eventName: 'NEW_QUOTATION_LANDED',
      eventParams: {
        page_type: 'new_quotation'
      },
    },
    editQuotationLanded: {
      eventName: 'EDIT_QUOTATION_LANDED',
      eventParams: {
        page_type: 'edit_quotation'
      },
    },
    
    // CRUD Operations
    created: {
      eventName: 'QUOTATION_CREATED',
      eventParams: {
        action: 'create',
        success: true
      },
    },
    updated: {
      eventName: 'QUOTATION_UPDATED',
      eventParams: {
        action: 'update',
        success: true
      },
    },
    deleted: {
      eventName: 'QUOTATION_DELETED',
      eventParams: {
        action: 'delete',
        success: true
      },
    },
    cloned: {
      eventName: 'QUOTATION_CLONED',
      eventParams: {
        action: 'clone',
        success: true
      },
    },
    pdfGenerated: {
      eventName: 'QUOTATION_PDF_GENERATED',
      eventParams: {
        action: 'pdf_generation',
        success: true
      },
    },
    
    // User Actions
    createStarted: {
      eventName: 'QUOTATION_CREATE_STARTED',
      eventParams: {
        action: 'create_started'
      },
    },
    editStarted: {
      eventName: 'QUOTATION_EDIT_STARTED',
      eventParams: {
        action: 'edit_started'
      },
    },
    deleteStarted: {
      eventName: 'QUOTATION_DELETE_STARTED',
      eventParams: {
        action: 'delete_started'
      },
    },
    cloneStarted: {
      eventName: 'QUOTATION_CLONE_STARTED',
      eventParams: {
        action: 'clone_started'
      },
    },
    pdfStarted: {
      eventName: 'QUOTATION_PDF_STARTED',
      eventParams: {
        action: 'pdf_started'
      },
    },
    
    // Form Interactions
    tableTypeSelected: {
      eventName: 'QUOTATION_TABLE_TYPE_SELECTED',
      eventParams: {
        action: 'table_type_selection'
      },
    },
    tableTypeCreated: {
      eventName: 'QUOTATION_TABLE_TYPE_CREATED',
      eventParams: {
        action: 'table_type_creation',
        success: true
      },
    },
    gstinAutoFilled: {
      eventName: 'QUOTATION_GSTIN_AUTO_FILLED',
      eventParams: {
        action: 'gstin_auto_fill',
        success: true
      },
    },
    
    // Errors and Issues
    creationFailed: {
      eventName: 'QUOTATION_CREATION_FAILED',
      eventParams: {
        action: 'create',
        success: false
      },
    },
    updateFailed: {
      eventName: 'QUOTATION_UPDATE_FAILED',
      eventParams: {
        action: 'update',
        success: false
      },
    },
    deleteFailed: {
      eventName: 'QUOTATION_DELETE_FAILED',
      eventParams: {
        action: 'delete',
        success: false
      },
    },
    pdfFailed: {
      eventName: 'QUOTATION_PDF_FAILED',
      eventParams: {
        action: 'pdf_generation',
        success: false
      },
    },
    validationError: {
      eventName: 'QUOTATION_VALIDATION_ERROR',
      eventParams: {
        action: 'validation_error'
      },
    },
    
    // Performance and UX
    formAbandoned: {
      eventName: 'QUOTATION_FORM_ABANDONED',
      eventParams: {
        action: 'form_abandoned'
      },
    },
    saveClicked: {
      eventName: 'QUOTATION_SAVE_CLICKED',
      eventParams: {
        action: 'save_clicked'
      },
    },
    cancelClicked: {
      eventName: 'QUOTATION_CANCEL_CLICKED',
      eventParams: {
        action: 'cancel_clicked'
      },
    },
  },
  
  // Table Configuration Analytics Events
  tableConfiguration: {
    // Page Views
    landed: {
      eventName: 'TABLE_CONFIGURATION_LANDED',
      eventParams: {
        page_type: 'table_configuration_list'
      },
    },
    
    // CRUD Operations
    created: {
      eventName: 'TABLE_CONFIGURATION_CREATED',
      eventParams: {
        action: 'create',
        success: true
      },
    },
    updated: {
      eventName: 'TABLE_CONFIGURATION_UPDATED',
      eventParams: {
        action: 'update',
        success: true
      },
    },
    deleted: {
      eventName: 'TABLE_CONFIGURATION_DELETED',
      eventParams: {
        action: 'delete',
        success: true
      },
    },
    
    // User Actions
    createStarted: {
      eventName: 'TABLE_CONFIGURATION_CREATE_STARTED',
      eventParams: {
        action: 'create_started'
      },
    },
    editStarted: {
      eventName: 'TABLE_CONFIGURATION_EDIT_STARTED',
      eventParams: {
        action: 'edit_started'
      },
    },
    deleteStarted: {
      eventName: 'TABLE_CONFIGURATION_DELETE_STARTED',
      eventParams: {
        action: 'delete_started'
      },
    },
    
    // Form Interactions
    columnCountChanged: {
      eventName: 'TABLE_CONFIGURATION_COLUMN_COUNT_CHANGED',
      eventParams: {
        action: 'column_count_change'
      },
    },
    gstRowToggled: {
      eventName: 'TABLE_CONFIGURATION_GST_ROW_TOGGLED',
      eventParams: {
        action: 'gst_row_toggle'
      },
    },
    
    // Errors
    creationFailed: {
      eventName: 'TABLE_CONFIGURATION_CREATION_FAILED',
      eventParams: {
        action: 'create',
        success: false
      },
    },
    updateFailed: {
      eventName: 'TABLE_CONFIGURATION_UPDATE_FAILED',
      eventParams: {
        action: 'update',
        success: false
      },
    },
    deleteFailed: {
      eventName: 'TABLE_CONFIGURATION_DELETE_FAILED',
      eventParams: {
        action: 'delete',
        success: false
      },
    },
  },
  
  // Tutorial Analytics Events
  tutorial: {
    // Page Views
    listLanded: {
      eventName: 'TUTORIAL_LIST_LANDED',
      eventParams: {
        page_type: 'tutorial_list'
      },
    },
    detailLanded: {
      eventName: 'TUTORIAL_DETAIL_LANDED',
      eventParams: {
        page_type: 'tutorial_detail'
      },
    },
    
    // User Actions
    tutorialClicked: {
      eventName: 'TUTORIAL_CLICKED',
      eventParams: {
        action: 'tutorial_clicked'
      },
    },
    searchPerformed: {
      eventName: 'TUTORIAL_SEARCH_PERFORMED',
      eventParams: {
        action: 'search'
      },
    },
    relatedTutorialClicked: {
      eventName: 'RELATED_TUTORIAL_CLICKED',
      eventParams: {
        action: 'related_tutorial_clicked'
      },
    },
    backButtonClicked: {
      eventName: 'TUTORIAL_BACK_BUTTON_CLICKED',
      eventParams: {
        action: 'back_navigation'
      },
    },
    allTutorialsClicked: {
      eventName: 'ALL_TUTORIALS_CLICKED',
      eventParams: {
        action: 'all_tutorials_navigation'
      },
    },
    sidebarMenuClicked: {
      eventName: 'TUTORIAL_SIDEBAR_MENU_CLICKED',
      eventParams: {
        action: 'sidebar_menu_click',
        source: 'sidebar_menu',
        opens_in_new_tab: true
      },
    },
  },
  
  // Blog Analytics Events
  blog: {
    // Page Views
    listLanded: {
      eventName: 'BLOG_LIST_LANDED',
      eventParams: {
        page_type: 'blog_list'
      },
    },
    detailLanded: {
      eventName: 'BLOG_DETAIL_LANDED',
      eventParams: {
        page_type: 'blog_detail'
      },
    },
    
    // User Actions
    blogClicked: {
      eventName: 'BLOG_POST_CLICKED',
      eventParams: {
        action: 'blog_clicked'
      },
    },
    searchPerformed: {
      eventName: 'BLOG_SEARCH_PERFORMED',
      eventParams: {
        action: 'search'
      },
    },
    categoryFiltered: {
      eventName: 'BLOG_CATEGORY_FILTERED',
      eventParams: {
        action: 'category_filter'
      },
    },
    relatedPostClicked: {
      eventName: 'BLOG_RELATED_POST_CLICKED',
      eventParams: {
        action: 'related_post_clicked'
      },
    },
    backButtonClicked: {
      eventName: 'BLOG_BACK_BUTTON_CLICKED',
      eventParams: {
        action: 'back_navigation'
      },
    },
    tutorialLinkClicked: {
      eventName: 'BLOG_TUTORIAL_LINK_CLICKED',
      eventParams: {
        action: 'tutorial_link_clicked'
      },
    },
    ctaClicked: {
      eventName: 'BLOG_CTA_CLICKED',
      eventParams: {
        action: 'cta_clicked'
      },
    },
    appDownloadClicked: {
      eventName: 'BLOG_APP_DOWNLOAD_CLICKED',
      eventParams: {
        action: 'app_download_clicked'
      },
    },
    headerMenuClicked: {
      eventName: 'BLOG_HEADER_MENU_CLICKED',
      eventParams: {
        action: 'header_menu_click',
        source: 'header_menu'
      },
    },
  }
}
